import React, { FC, useState } from 'react'
import Button from '../../../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'
import Info from 'src/components/Atoms/Info/Info'
import Font from 'src/components/Core/Typography/Font/Font'
import storage from 'src/components/Core/Utils/storage'
import { Trans } from 'react-i18next'
import { useDropdownOptions } from 'src/components/Core/Context/OnboardingContext'

const showInfoKey = storage?.keys?.store?.onboarding?.companyDetails?.showInfo

const CompanyDetailsForm: FC<FormProps> = props => {
  const [showInfo, setShowInfo] = useState(storage.get(showInfoKey) === null)
  const { dropdownOptions } = useDropdownOptions()

  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const {
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    configData,
  } = useForm(props.fetchedData, config({ countries: dropdownOptions.countries, countryTelephoneCodes: dropdownOptions.countryTelephoneCodes, formType: props.formType }), submitForm)

  const closeInfo = () => {
    storage.set(showInfoKey, false)
    setShowInfo(false)
  }

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.CorporateAccount.CompanyDetailsForm.title')}
        </FormTitle>
      </FormHeader>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      {showInfo && (
        <Info closeInfo={closeInfo}>
          <Font>
            {/* @ts-ignore-next-line */}
            <Trans i18nKey='onboarding.forms.CorporateAccount.CompanyDetailsForm.info.content' />
          </Font>
        </Info>
      )}
      <FormFooter>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default CompanyDetailsForm
